"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VisualInterestColorName = void 0;

var _parseToRgb = _interopRequireDefault(require("polished/lib/color/parseToRgb"));

var _base = _interopRequireDefault(require("./base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BERRY_CRISP_DARK = (0, _parseToRgb.default)('#672A97');
var BERRY_CRISP_MEDIUM = (0, _parseToRgb.default)('#BD52F7');
var BERRY_CRISP_LIGHT = (0, _parseToRgb.default)('#E9CAFB');
var KOOLAID_CAKE_DARK = (0, _parseToRgb.default)('#552592');
var KOOLAID_CAKE_MEDIUM = (0, _parseToRgb.default)('#8255E0');
var KOOLAID_CAKE_LIGHT = (0, _parseToRgb.default)('#E4D6F8');
var COOKIE_MONSTER_DARK = (0, _parseToRgb.default)('#3E2F9A');
var COOKIE_MONSTER_MEDIUM = (0, _parseToRgb.default)('#4F69ED');
var COOKIE_MONSTER_LIGHT = (0, _parseToRgb.default)('#CADCFF');
var COTTON_CANDY_DARK = (0, _parseToRgb.default)('#00838C');
var COTTON_CANDY_MEDIUM = (0, _parseToRgb.default)('#1FD6E1');
var COTTON_CANDY_LIGHT = (0, _parseToRgb.default)('#B2F4F7');
var FIZZY_LIME_DARK = (0, _parseToRgb.default)('#6B7700');
var FIZZY_LIME_MEDIUM = (0, _parseToRgb.default)('#C8DE00');
var FIZZY_LIME_LIGHT = (0, _parseToRgb.default)('#E8F5B3');
var MAMBO_MANGO_DARK = (0, _parseToRgb.default)('#827323');
var MAMBO_MANGO_MEDIUM = (0, _parseToRgb.default)('#FFD916');
var MAMBO_MANGO_LIGHT = (0, _parseToRgb.default)('#FCF6B1');
var CARROT_CAKE_DARK = (0, _parseToRgb.default)('#B93F06');
var CARROT_CAKE_MEDIUM = (0, _parseToRgb.default)('#FF6E31');
var CARROT_CAKE_LIGHT = (0, _parseToRgb.default)('#FFD6B9');
var ROSE_GUMMY_DARK = (0, _parseToRgb.default)('#A5003F');
var ROSE_GUMMY_MEDIUM = (0, _parseToRgb.default)('#E63462');
var ROSE_GUMMY_LIGHT = (0, _parseToRgb.default)('#FFD0E6');
var LICORICE_MOUSSE_DARK = (0, _parseToRgb.default)('#595A68');
var LICORICE_MOUSSE_MEDIUM = (0, _parseToRgb.default)('#9C9FAB');
var LICORICE_MOUSSE_LIGHT = (0, _parseToRgb.default)('#D4D9E2');
var VisualInterestColorName;
exports.VisualInterestColorName = VisualInterestColorName;

(function (VisualInterestColorName) {
  VisualInterestColorName["berryCrisp"] = "berryCrisp";
  VisualInterestColorName["koolaidCake"] = "koolaidCake";
  VisualInterestColorName["cookieMonster"] = "cookieMonster";
  VisualInterestColorName["cottonCandy"] = "cottonCandy";
  VisualInterestColorName["fizzyLime"] = "fizzyLime";
  VisualInterestColorName["mamboMango"] = "mamboMango";
  VisualInterestColorName["carrotCake"] = "carrotCake";
  VisualInterestColorName["roseGummy"] = "roseGummy";
  VisualInterestColorName["licoriceMousse"] = "licoriceMousse";
})(VisualInterestColorName || (exports.VisualInterestColorName = VisualInterestColorName = {}));

var visualInterest = {
  berryCrisp: {
    light: _objectSpread({}, BERRY_CRISP_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, BERRY_CRISP_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, BERRY_CRISP_DARK, {
      fg: _base.default.snowWhite
    })
  },
  koolaidCake: {
    light: _objectSpread({}, KOOLAID_CAKE_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, KOOLAID_CAKE_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, KOOLAID_CAKE_DARK, {
      fg: _base.default.snowWhite
    })
  },
  cookieMonster: {
    light: _objectSpread({}, COOKIE_MONSTER_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, COOKIE_MONSTER_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, COOKIE_MONSTER_DARK, {
      fg: _base.default.snowWhite
    })
  },
  cottonCandy: {
    light: _objectSpread({}, COTTON_CANDY_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, COTTON_CANDY_MEDIUM, {
      fg: _base.default.charcoal
    }),
    dark: _objectSpread({}, COTTON_CANDY_DARK, {
      fg: _base.default.snowWhite
    })
  },
  fizzyLime: {
    light: _objectSpread({}, FIZZY_LIME_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, FIZZY_LIME_MEDIUM, {
      fg: _base.default.charcoal
    }),
    dark: _objectSpread({}, FIZZY_LIME_DARK, {
      fg: _base.default.snowWhite
    })
  },
  mamboMango: {
    light: _objectSpread({}, MAMBO_MANGO_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, MAMBO_MANGO_MEDIUM, {
      fg: _base.default.charcoal
    }),
    dark: _objectSpread({}, MAMBO_MANGO_DARK, {
      fg: _base.default.snowWhite
    })
  },
  carrotCake: {
    light: _objectSpread({}, CARROT_CAKE_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, CARROT_CAKE_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, CARROT_CAKE_DARK, {
      fg: _base.default.snowWhite
    })
  },
  roseGummy: {
    light: _objectSpread({}, ROSE_GUMMY_LIGHT, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, ROSE_GUMMY_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, ROSE_GUMMY_DARK, {
      fg: _base.default.snowWhite
    })
  },
  licoriceMousse: {
    dark: _objectSpread({}, LICORICE_MOUSSE_DARK, {
      fg: _base.default.snowWhite
    }),
    medium: _objectSpread({}, LICORICE_MOUSSE_MEDIUM, {
      fg: _base.default.snowWhite
    }),
    light: _objectSpread({}, LICORICE_MOUSSE_LIGHT, {
      fg: _base.default.charcoal
    })
  }
};
var _default = visualInterest;
exports.default = _default;